import React from "react";

function TicketerButton(props) {

  return (
    <button className="ticketer-button" onClick={ props.function }>{ props.text }</button>       
  );
}

export default TicketerButton;